import { LargeText } from '@epilot/journey-elements'
import { useTranslation } from 'react-i18next'

import { MaterialSymbol } from '../../../../components/MaterialSymbol'
import { getFormattedLocaleNumber } from '../utils'

import { useWidgetStyles } from './styles'
import { WidgetContainer } from './WidgetContainer'

export const RooftopDataWidget = ({
  isTetraederApiFF,
  maxSunshineHoursPerYear,
  maxArrayAreaMeters2,
  maxArrayPanelsCount
}: {
  isTetraederApiFF: boolean
  maxSunshineHoursPerYear?: number | undefined
  maxArrayAreaMeters2: number | undefined
  maxArrayPanelsCount?: number
}) => {
  const classes = useWidgetStyles()
  const { t } = useTranslation()

  return (
    <WidgetContainer>
      <LargeText className={classes.title}>
        {t('rooftop_planner.rooftop_title')}
      </LargeText>
      {!isTetraederApiFF && (
        <div className={classes.line}>
          <div className={classes.textContainer}>
            <MaterialSymbol
              color="primary"
              name="light_mode"
              settings={{ fill: true, size: 22 }}
            />
            <span>{t('rooftop_planner.sunshine_hours')}</span>
          </div>
          <span className={classes.dataCell}>
            {maxSunshineHoursPerYear
              ? `${getFormattedLocaleNumber(maxSunshineHoursPerYear)} ${t('units.hours')}`
              : '-'}
          </span>
        </div>
      )}
      <div className={classes.line}>
        <div className={classes.textContainer}>
          <MaterialSymbol
            color="primary"
            name="pageless"
            settings={{ fill: true, size: 22 }}
          />
          <span>{t('rooftop_planner.rooftop_surface')}</span>
        </div>
        <span className={classes.dataCell}>
          {maxArrayAreaMeters2
            ? `${getFormattedLocaleNumber(maxArrayAreaMeters2)} m²`
            : '-'}
        </span>
      </div>
      {isTetraederApiFF && maxArrayPanelsCount && (
        <div className={classes.line}>
          <div className={classes.textContainer}>
            <MaterialSymbol
              color="primary"
              name="solar_power"
              settings={{ fill: true, size: 22 }}
            />
            <span>{t('rooftop_planner.max_solar_panels')}</span>
          </div>
          <span className={classes.dataCell}>{maxArrayPanelsCount}</span>
        </div>
      )}
    </WidgetContainer>
  )
}
